import EventBase from './EventBase'
import EventID from './EventID'

/**
 * 604 - 显示视频结束事件
 */

export default class EventMediaPlayOver extends EventBase {
  Code = EventID.MediaPlayEnd
  constructor() {
    super()
    this.Parameter = ['0']
  }
  /**
   * 视频ID
   */
  get VideoId() {
    return parseInt(this.Parameter?.[0] ?? '')
  }
  set VideoId(value) {
    this.Parameter && (this.Parameter[0] = value.toString())
  }

  /**
   * 描述信息
   */
  get Description() {
    return this.Parameter?.[0] || ''
  }
  set Description(value) {
    this.Parameter && (this.Parameter[0] = value.toString())
  }

}
